import React from 'react';

/**
 * Utilities
*/
import { fetchReports } from '../../utils/api';
import { findStoredReportByUserId } from '../../utils/reports';

/**
 * Contexts
 */
import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';

/**
 * MUI Components
 */
import { Typography } from '@mui/material';

/**
 * Components
 */
import ListReports from '../../components/Reports/ListReports';
import ListLocalReports from '../../components/Reports/ListLocalReports';

/**
 * Hooks
 */
import useToken from '../../hooks/useToken';
import { useTranslation } from 'react-i18next';
import { useAppMenu } from '../../contexts/NavBarContext';
import { useState, useRef, useEffect } from 'react';

const MyReportsPage = () => {
    const appData = useContext(AppContext);
    const { t } = useTranslation();
    const { token } = useToken();
    const { updateTitle } = useAppMenu();
    const [reports, setReports] = useState(null);
    const [isBusy, setIsBusy] = useState(false);
    const [error, setError] = useState(null);
    const abortControllerRef = useRef(new AbortController());
    const [offlineReports, setOfflineReports] = useState(null);

    updateTitle(t('My reports'));

    const loadReports = async () => {
        setIsBusy(true);
        setError(null);

        try {
            const result = await fetchReports(token, {}, abortControllerRef.current.signal);
            if (result.message == 'ok') {
                setReports(result.reports);
            } else {
                console.log('Unknown response:', result);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsBusy(false);
        }
    };

    const loadLocalStoredReports = () => {
        let uid = appData.userInfo?.id || 0;

        if (uid > 0) {
            const storedReports = findStoredReportByUserId(uid);
            setOfflineReports(storedReports);
        } else {
            console.warn('Cannot load local stored reports since there is no user id');
        }
    };

    useEffect(() => {

        loadReports();
        loadLocalStoredReports();

        // Cleanup function to abort the fetch if the component unmounts
        return () => {
            abortControllerRef.current.abort();
        };
    }, []);

    return (
        <>
            <Typography variant="h6" color={'text.secondary'} sx={{ mb: 2, textAlign: 'center', padding: 2 }}>
                {t('Showing your last reports')}
            </Typography>
            {offlineReports && offlineReports.length > 0 && (
                <ListLocalReports keys={offlineReports} />
            )}

            {reports && (
                <ListReports reports={reports} />
            )}
        </>
    );
};

export default MyReportsPage;
